import en from './en.json'
import jp from './jp.json'
import de from './de.json'

export default document.querySelector('body').getAttribute('data-locale') === 'jp-JP' ? jp : document.querySelector('body').getAttribute('data-locale') === 'de-DE' ? de : en // TODO: make more dynamic
